<template>
  <div>

    <Card>
      <Row :gutter="24">
          <!-- <Col span="3">
            <Button type="primary" @click="add">新增</Button>
          </Col> -->
          <Col span="3">
              <Input v-model="params.name" @on-change="getSoftwareAssetsWorkflow">
                  <span slot="prepend">申请人</span>
              </Input>
          </Col>
          <Col span="3">
            <Input v-model="params.approval_name" @on-change="getSoftwareAssetsWorkflow">
                <span slot="prepend">审批人</span>
            </Input>
          </Col>
          <Col span="3">
            <Input v-model="params.department" @on-change="getSoftwareAssetsWorkflow">
                <span slot="prepend">部门</span>
            </Input>
          </Col>
          <Col span="3">
              <Button type="text" icon="md-refresh-circle" @click="getSoftwareAssetsWorkflow"></Button>
          </Col>
      </Row>
    </Card>

    <Table highlight-row ref="currentRowTable" :columns="workflowColumns" :data="assetList"></Table>
    <Page :total="count" :current="params.page" show-sizer show-total :page-size="params.size" @on-change="currentHandle" @on-page-size-change="pageSizeHandle"></Page>

    <Drawer :title="formItem.id ? '编辑' : '新增'" v-model="drawerChange" width="672" :mask-closable="false" @on-close="drawerChange=false">
      <i-form ref="formItem" :model="formItem" :label-width="80" :rules="ruleValidate">

        <form-item label="姓名" prop="name">
          <i-input v-model="formItem.name" placeholder="" :disabled='true'></i-input>
        </form-item>

        <form-item label="邮箱" prop="mail">
          <i-input v-model="formItem.mail" placeholder="" :disabled='true'></i-input>
        </form-item>

        <form-item label="部门" prop="department">
          <!-- <Select v-model="formItem.department" @on-change="selectDepartment" >
            <Option v-for="item in distribute" :value="item.id" :key="item.id">{{ item.department }}</Option>
          </Select> -->
          <i-input v-model="formItem.department" placeholder="" :disabled='true'></i-input>
        </form-item>

        <form-item label="授权软件" prop="department">
          <Transfer
            :data="software_assets_price"
            :target-keys="formItem.software_id_list"
            filterable
            :filter-method="filterMethod"
            :render-format="renderFormat"
            :list-style="{
              width: '300px',
              height: '200px'
            }"
            @on-change="handleChangeAuthorize">
          </Transfer>
        </form-item>

        <!-- <form-item label="按年的价格" prop="year_price">
          <i-input v-model="formItem.year_price" placeholder="" :disabled='true'></i-input>
        </form-item>

        <form-item label="永久的价格" prop="forever_price">
          <i-input v-model="formItem.forever_price" placeholder="" :disabled='true'></i-input>
        </form-item>

        <form-item label="总价" prop="total_price">
          <i-input v-model="formItem.total_price" placeholder="" :disabled='true'></i-input>
        </form-item> -->

        <form-item label="价格描述" prop="total_price">
          <Input class="myinput" v-model="describe" disabled type="textarea" placeholder="" :rows="3" style="color: red;"/>
        </form-item>

        <form-item label="备注" prop="remark">
          <i-input v-model="formItem.remark" placeholder=""></i-input>
        </form-item>

        <form-item>
          <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
          <i-button style="margin-left: 8px" @click="drawerChange=false">取消</i-button>
        </form-item>

      </i-form>

      <spin fix v-if="changeLoadingShow">
        <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
        <div>请求中....</div>
      </spin>

    </Drawer>

    <Modal v-model="logModal" title="日志" :mask-closable="false" :scrollable="true">
        <template>
          <Timeline>
              <TimelineItem :color="item.content.indexOf('新增') !== -1 ? 'green' : 'red'" v-for="(item, index) in logs" :key="index">
                <p class="time">{{ item.created_at }}</p>
                <p class="content">{{ item.content }}</p>
                <p class="content">{{ item.remark }}</p>
              </TimelineItem>
          </Timeline>
        </template>
    </Modal>

    <Modal v-model="approvalModal" title="审批指派" :mask-closable="false" :scrollable="true" @on-ok="handleSubmit('formItem')">
      <template>
        <Treeselect :async="true" v-model="formItem.approval_name" valueConsistsOf='LEAF_PRIORITY' valueFormat="object" clearable @input="eventInput"
                      :multiple="false" :load-options="loadOptionsAsync" :searchable="true" :disableBranchNodes="true" placeholder="人员模糊查找">
          <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
            <img v-if="node.raw.avatar" width="10" height="10" :src="node.raw.avatar"/>{{ node.label }}
          </label>
          </Treeselect>
      </template>
  </Modal>

  </div>
</template>

<script>
import moment from 'moment'
import { getSoftwareAssetsDistribute, getSoftwareAssetsWorkflow, addSoftwareAssetsWorkflow, updateSoftwareAssetsWorkflow, deleteSoftwareAssetsWorkflow,
  addSoftwareAssetsLog, getSoftwareAssetsLog, getSoftwareAssetsPrice, getPeopleLst } from '@/api/cmdb'
import { Treeselect, ASYNC_SEARCH } from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  name: 'softwareWorkflow',
  components: { Treeselect },
  data () {
    return {
      formItem: {
        software_id_list: [],
        software_list: [],
        name: this.$store.state.user.name,
        mail: this.$store.state.user.user.email,
        userid: this.$store.state.user.userId,
        workflow_at: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        department: null,
        // total_price: 0,
        // year_price: 0,
        // forever_price: 0,
        remark: null
      },
      formItemSource: {},
      logs: [],
      distribute: [],
      describe: '',
      ruleValidate: {
        // total_price: [
        //   { required: true, message: '价格不能为空', trigger: 'blur' }
        // ]
      },
      workflowColumns: [

        {
          width: 60,
          align: 'center',
          key: 'id',
          ellipsis: true,
          tooltip: true
        },

        {
          title: '授权软件',
          key: 'software_id_list_info',
          ellipsis: true,
          tooltip: true,
          minWidth: 600,
          align: 'center',
          render: (h, params) => {
            return h('span', { }, [
              params.row.software_list.map((item, _) => {
                return h('Tag', {
                  props: {
                    type: 'border',
                    color: '#7232dd'
                  },
                  style: {
                    marginLeft: '5px',
                    display: item.name ? 'inline-block' : 'none'
                  }
                }, item.name)
              })
            ]
            )
          }
        },

        {
          title: '姓名',
          key: 'name',
          ellipsis: true,
          tooltip: true,
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            return h('a', {
              props: {
                type: 'warning',
                size: 'small'
              },
              on: {
                click: () => {
                  this.logModal = true
                  getSoftwareAssetsLog({ software_assets_workflow_id: params.row.id, page: 1, size: 1000 }).then(rsp => {
                    const { results } = rsp.data
                    this.logs = results
                  })
                }
              }
            }, params.row.name)
          }
        },

        {
          title: '邮箱',
          key: 'mail',
          align: 'center',
          minWidth: 180,
          ellipsis: true,
          tooltip: true
        },

        {
          title: '部门',
          key: 'department',
          align: 'center',
          minWidth: 180,
          ellipsis: true,
          tooltip: true
        },

        /* {
          title: '部门',
          key: 'department_info',
          minWidth: 180,
          align: 'center',
          ellipsis: true,
          tooltip: true,
          render: (h, params) => {
            return h('div', {}, params.row.department_info.department)
          }
        }, */

        {
          title: '申请时间',
          key: 'workflow_at',
          minWidth: 180,
          align: 'center',
          ellipsis: true,
          tooltip: true
        },

        {
          title: '总价',
          key: 'total_price',
          minWidth: 180,
          align: 'center',
          ellipsis: true,
          tooltip: true
        },

        // {
        //   title: '总价',
        //   key: 'total_price',
        //   minWidth: 180,
        //   align: 'center',
        //   ellipsis: true,
        //   tooltip: true
        // },

        // {
        //   title: '按年的价格',
        //   key: 'year_price',
        //   minWidth: 180,
        //   align: 'center',
        //   ellipsis: true,
        //   tooltip: true
        // },

        // {
        //   title: '永久的价格',
        //   key: 'forever_price',
        //   minWidth: 180,
        //   align: 'center',
        //   ellipsis: true,
        //   tooltip: true
        // },

        {
          title: '申请状态',
          key: 'approval_status',
          minWidth: 100,
          align: 'center',
          ellipsis: true,
          tooltip: true,
          render: (h, params) => {
            return h('div', [
              h('Tag', {
                props: {
                  color: params.row.approval_status === '处理中' ? '#7232dd' : params.row.approval_status === '审批中' || params.row.approval_status === '驳回' ? 'red' : 'green'
                }
              }, params.row.approval_status)
            ])
          }
        },

        {
          title: '操作人',
          key: 'operator_info',
          minWidth: 180,
          ellipsis: true,
          tooltip: true,
          align: 'center',
          render: (h, params) => {
            return h('div', {}, params.row.operator_info.name)
          }
        },

        {
          title: '审批人',
          key: 'approval_name',
          minWidth: 180,
          align: 'center',
          ellipsis: true,
          tooltip: true
        },

        {
          title: '审批人邮箱',
          key: 'approval_mail',
          minWidth: 180,
          align: 'center',
          ellipsis: true,
          tooltip: true
        },

        // {
        //   title: '授权人',
        //   key: 'authorization_user',
        //   ellipsis: true,
        //   tooltip: true,
        //   minWidth: 80,
        //   align: 'center',
        //   render: (h, params) => {
        //     return h('div', {}, params.row.authorization_user_info.name)
        //   }
        // },

        {
          title: '备注',
          key: 'remark',
          minWidth: 180
        },

        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          minWidth: 180,
          render: (h, params) => {
            let groups = []
            this.$store.state.user.groups.forEach(_g => {
              groups.push(_g.name)
            })
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  display: (groups.indexOf('软件审批') !== -1 || this.$store.state.user.superuser) && params.row.approval_status === '待处理' ? 'inline-block' : 'none'
                },
                on: {
                  click: () => {
                    this.formItem = params.row
                    this.formItemSource = { ...params.row }
                    this.drawerChange = true
                  }
                }
              }, '编辑'),
              h('Poptip', {
                props: {
                  confirm: true,
                  transfer: true,
                  placement: 'bottom',
                  title: '你确定要删除吗?'
                },
                style: {
                  display: (groups.indexOf('软件审批') !== -1 || this.$store.state.user.superuser) ? 'inline-block' : 'none'
                },
                on: {
                  'on-ok': () => {
                    deleteSoftwareAssetsWorkflow({ id: params.row.id }).then(_ => {
                      this.getSoftwareAssetsWorkflow()
                    })
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '删除')
              ]),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  display: (groups.indexOf('软件审批') !== -1 || this.$store.state.user.superuser) && params.row.approval_status === '待处理' ? 'inline-block' : 'none'
                },
                on: {
                  click: () => {
                    this.formItem = { ...params.row }
                    this.formItemSource = { ...params.row }
                    this.formItem.approval_status = '审批中'
                    this.formItem.approval_name = this.formItem.approval_name ? { id: this.formItem.approval_name, label: this.formItem.approval_name } : null
                    this.approvalModal = true
                    getSoftwareAssetsDistribute({ page: 1, size: 10, department: this.formItem.department }).then(rsp => {
                      const { results } = rsp.data
                      if (results) {
                        this.formItem.approval_name = results[0].director_name ? { id: results[0].director_name, label: results[0].director_name } : null
                      }
                    })
                  }
                }
              }, '指派')
            ])
          }
        }
      ],
      params: { page: 1, size: 10 },
      assetList: [],
      software_assets_price: [],
      software_assets_price_dict: {},
      count: 0,
      drawerChange: false,
      changeLoadingShow: false,
      logModal: false,
      approvalModal: false
    }
  },

  mounted () {
    this.getSoftwareAssetsWorkflow()
  },

  methods: {
    add () {
      this.drawerChange = true
      this.formItem = {
        software_id_list: [],
        software_list: [],
        name: this.$store.state.user.name,
        mail: this.$store.state.user.user.email,
        userid: this.$store.state.user.userId,
        workflow_at: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        department: null,
        // total_price: 0,
        // year_price: 0,
        // forever_price: 0,
        remark: null
      }
    },

    getSoftwareAssetsWorkflow () {
      getSoftwareAssetsWorkflow(this.params).then(rsp => {
        const { results, count } = rsp.data
        this.assetList = results
        this.count = count
      })
      getSoftwareAssetsPrice({ page: 1, size: 10000 }).then(rsp => {
        const { results } = rsp.data
        this.software_assets_price = []
        this.software_assets_price_dict = {}
        results.forEach(_r => {
          this.software_assets_price.push({ key: _r.id, label: _r.name, disabled: false, price: _r.price, currency: _r.currency })
          this.software_assets_price_dict[_r.id] = _r
        })
        console.log(this.software_assets_price)
      })

      getSoftwareAssetsDistribute({ page: 1, size: 10000 }).then(rsp => {
        const { results } = rsp.data
        this.distribute = results
      })
    },

    currentHandle (page) {
      this.params.page = page
      this.getSoftwareAssetsWorkflow()
    },

    pageSizeHandle (size) {
      this.params.size = size
      this.getSoftwareAssetsWorkflow()
    },

    filterMethod (data, query) {
      return data.label.indexOf(query) > -1
    },

    handleChangeAuthorize (newTargetKeys, direction, moveKeys) {
      this.formItem.software_id_list = newTargetKeys
      // this.formItem.total_price = 0
      // this.formItem.year_price = 0
      // this.formItem.forever_price = 0
      this.formItem.software_list = []
      this.describe = ''
      newTargetKeys.forEach(_id => {
        // if (this.software_assets_price_dict[_id].authorization_type.indexOf('按年') !== -1) {
        //   this.formItem.year_price += this.software_assets_price_dict[_id].price
        // }
        // if (this.software_assets_price_dict[_id].authorization_type.indexOf('永久') !== -1) {
        //   this.formItem.forever_price += this.software_assets_price_dict[_id].price
        // }
        // this.formItem.total_price += this.software_assets_price_dict[_id].price
        this.describe += `${this.software_assets_price_dict[_id].name}/${this.software_assets_price_dict[_id].authorization_type}: ${this.software_assets_price_dict[_id].price}  (${this.software_assets_price_dict[_id].currency})\n`
        this.formItem.software_list.push(this.software_assets_price_dict[_id])
      })
    },

    renderFormat (item) {
      return `<span title="${item.label + ' （' + item.price + ' ' + item.currency}")>${item.label + ' (' + item.price + ' ' + item.currency + ')'}</span>`
    },

    handleSubmit (name) {
      let that = this.formItem
      let remark = {}
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (that.software_id_list.length === 0) {
            this.$Notice.error({ title: '软件不能为空' })
            return
          }
          Object.keys(this.formItem).forEach(_key => {
            if (this.formItem[_key] !== this.formItemSource[_key]) {
              remark[_key] = `${this.formItemSource[_key]} -> ${this.formItem[_key]}`
            }
          })
          if (typeof (that.approval_name) !== 'string') {
            that.approval_name = that.approval_name && 'label' in that.approval_name ? that.approval_name.label : ''
          }
          this.changeLoadingShow = true
          if (that.id) {
            if (this.formItem.approval_status === '审批中' && !this.formItem.approval_name) {
              this.$Notice.error({ title: '未获取到审批人信息！' })
              return
            }
            if (Object.keys(remark).length !== 0) {
              updateSoftwareAssetsWorkflow(that).then(rsp => {
                const { data } = rsp
                this.getSoftwareAssetsWorkflow()
                addSoftwareAssetsLog({ log_type: '授权软件申请', content: '修改', operator_id: this.$store.state.user.userId, software_assets_workflow: data.id, remark: JSON.stringify(remark) })
                this.changeLoadingShow = false
                this.drawerChange = false
                this.$Notice.success({ title: '修改成功' })
              }).catch(_ => {
                this.changeLoadingShow = false
                this.drawerChange = false
                this.$Notice.error({ title: '异常!' })
              })
            } else {
              this.changeLoadingShow = false
              this.$Notice.error({ title: '无数据变化！' })
            }
          } else {
            addSoftwareAssetsWorkflow(that).then(rsp => {
              const { data } = rsp
              this.getSoftwareAssetsWorkflow()
              addSoftwareAssetsLog({ log_type: '授权软件申请', content: '新增', operator_id: this.$store.state.user.userId, software_assets_workflow: data.id, remark: JSON.stringify(this.formItem) })
              this.changeLoadingShow = false
              this.drawerChange = false
              this.$Notice.success({ title: '添加成功' })
            }).catch(_ => {
              this.changeLoadingShow = false
              this.drawerChange = false
              this.$Notice.error({ title: '异常!' })
            })
          }
        } else {
          this.changeLoadingShow = false
          this.$Notice.error({ title: '请检查输入框！' })
        }
      })
    },

    selectDepartment (value) {
      this.distribute.forEach(_distribute => {
        if (_distribute.id === value) {
          this.formItem.approval_name = _distribute.director_name
          this.formItem.approval_mail = _distribute.director_mail
          this.formItem.approval_userid = _distribute.director_userid
        }
      })
    },

    loadOptionsAsync ({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        // 异步搜索人员模式
        if (searchQuery) {
          let params = {
            parentid: 1,
            searchQuery: searchQuery,
            get_people: 1
          }
          getPeopleLst(params).then(res => {
            if (res.data.result) {
              callback(null, res.data.result)
            }
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '获取公司组织列表失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '获取公司组织列表失败！服务器无响应'
              })
            }
          })
        }
      }
    },

    eventInput (value) {
      // this.director_name = value.label
      this.formItem.approval_mail = value.email
      this.formItem.approval_userid = value.id
      this.formItem.operator = this.$store.state.user.userId
    }

  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
  .myinput .ivu-input[disabled], fieldset[disabled] .ivu-input :nth-last-child(1){
    color: red !important;
}
</style>
